import { createApp } from 'vue';
import App from './App.vue';
import './registerServiceWorker';
import './icons';

createApp(App).mount('#app');
